// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__ZYUqg","header":"MergedInvoice_header__21YGZ"};